import ErrorBoundary from 'src/components/ErrorBoundary';
import ShoppingListLayout from 'src/sections/shopping_lists/ShoppingListLayout';
import { ShoppingListProductsContextProvider } from 'src/sections/shopping_lists/ShoppingListProductsContext';

const ViewShoppingListsProducts = () => (
  <ErrorBoundary>
    <ShoppingListProductsContextProvider>
      <ShoppingListLayout />
    </ShoppingListProductsContextProvider>
  </ErrorBoundary>
);

export default ViewShoppingListsProducts;
